import React, {useContext, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, DeclineEstimateUrl} from "./Routes";
import {Col, Container, Row} from "bootstrap-4-react/lib/components/layout";
export default () => { //used to decline the estimate
    let RecordsController = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)
    let ContactInformationData = RecordsController.CP_PageDetails.ContactInformation
    let ContactPersons = ContactInformationData.ContactPersons
    const [ContactPersonId, SetContactPersonId] = useState({})
    const [TextValue, SetTextValue] = useState("")
    const [Reason, SetReason] = useState(true)

    const declineEstimate =  () => { // request is send to the "decline_estimate" function in Client_portal_controller"
        PageView.CloseModal() // used to close/hide the modal from the page.
        PageView.Set('LOADING')
        let event = {}
        event["estimate_id"] = Elink
        event["follow_up_status"] = true
        event["description"] = "declined"
        event["contact_person_id"] = ContactPersonId
        event["event_source_id"] = 12
        event["comment"] = TextValue
        axios({
            method: 'post',
            url: DeclineEstimateUrl,
            data: {
                event: event,
                estimate_key: Elink
            }
        }).then((response) => {
            let Message = response.data.Message
            if(Message && Message.Text === "Expired Link"){
                window.location.reload();
            }
            else{
                if (Message && Message.Status && Message.Status === "failed") {
                    PageView.setAlertProperty({
                        Message: Message.Text,
                        Type: Message.Type,
                        Show: true,
                        AutoHide: true
                    })
                    window.location.reload();
                } else {
                    window.open(response.data, '_self')
                }
            }
        })
    }
    const ContactPersonSelected = (i) => { // set id of the contact person
        SetContactPersonId(i)
    }

    const RejectReason = (i) => { // set the  reason for rejection
        SetTextValue(i)
    }

    const CheckReason = () => { // check validation on "Reason For Decline" field.
        if (TextValue === ""){
            SetReason(false)
        }
    }

    return(
        <>
            <form onSubmit={declineEstimate}>
                <div className={"mt-2 text-center"}>
                    <Row className={"mb-2"}>
                        <Col className={"text-start font-weight-bold"} style={{margin: 'auto'}}>
                            <label>
                                Person
                            </label>
                        </Col>
                        <Col style={{marginRight: "12%"}}>
                            <select id={"test_sel"} className="custom-select" onChange={(e) =>
                                ContactPersonSelected(e.target.value)} >
                                {ContactPersons.map((contact_person, key) => {
                                    return (
                                        <option value={contact_person.Id}>{contact_person.FullName}</option>
                                    )
                                })}
                            </select>
                        </Col>
                    </Row>

                    <Row>
                        <Col className={"text-start font-weight-bold"} style={{margin:'auto'}}><label>
                            Reason For Decline
                        </label></Col>
                        <Col style={{marginRight: "12%"}}><textarea style={Reason === false ? {border: '3px solid red',width: 'inherit'} : {width: 'inherit'}}
                                       className="form-control input_field_2"
                                       onChange={(e) => RejectReason(e.target.value)}
                                       rows={4}
                                       cols={10}
                        /></Col>
                    </Row>
                </div>

                <div className={"mt-3 text-center"}>
                    <input className= {'btn btn-primary'} style={{width: "30%"}}
                           type=  {TextValue === "" ? "" : "submit"} value="Not Interested" onClick = {()=> CheckReason()}/>
                        </div>
            </form>
        </>
    )
}